module.exports = __webpack_public_path__ + "static/media/equifax.6d696f30.png";